export const createDocument = (type, value) => ({
  type,
  number: value,
});
